import { observe, toJS } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Prompt, withRouter } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import { EButton, EInput } from 'src/Components/EInput';
import DeepCopy from 'src/UtilityFunctions/DeepCopy';
import { IPump, ITest } from '../../../../Interfaces/TestInterface';
import { IWell } from '../../../../Interfaces/WellInterface';
import { decimalPlaces } from '../../../../UtilityFunctions/DecimalPlaces';
import DataTable from '../../../DataTable';
import Footer from '../../../Footer';
import WorkflowHeader from '../../WorkflowHeader';


interface IList {
    headers: any[];
    rows: any[];
}

@inject('stores')
@observer
class DrillingPump extends React.Component {
    public props: any;
    private dataSet: IList;
    private test: ITest = new ITest();
    public TestsStore: any;
    private testDisposer: any;
    private well: IWell = new IWell();
    public WellsStore: any;
    private wellDisposer: any;
    private pump: IPump = new IPump();

    public state = {
        dataSet: this.dataSet,
        editing: false,
        isDirty: false,
        modal: false,
        pump: this.pump,
        rowIndex: 0,
        saveClicked: false,
        test: this.test,
        well: this.well
    };

    constructor(props: any) {
        super(props);
    
        this.TestsStore = this.props.stores.TestsStore;
        this.WellsStore = this.props.stores.WellsStore;

        this.clearDisposers = this.clearDisposers.bind(this);
    }

    public componentDidMount() {

        if ( this.props.stores.WellsStore.well && this.props.stores.TestsStore.test ) {
            this.setState({
                test: toJS(this.props.stores.TestsStore.test),
                well: toJS(this.props.stores.WellsStore.well)
            }, () => {
                this.formatDataTable();
            });
        } else {
            if ( ! this.TestsStore.test ) {
                this.TestsStore.getTestDetails(this.props.match.params.taskId, this.props.match.params.wellId);
            }
            if ( ! this.WellsStore.well ) {
                this.WellsStore.getWellDetails(this.props.match.params.wellId);
            }
        }
        this.createDisposers();
    }

    public createDisposers() {
        this.testDisposer = observe(this.TestsStore, 'test', (change: any) => {
            const test = toJS(change.newValue);
            this.setState({
                test
            }, () => {
                this.formatDataTable();
            });
        });
        this.wellDisposer = observe(this.WellsStore, 'well', (change: any) => {
            const well = toJS(change.newValue);
            this.setState({
                well
            });
        });
    }

    private handleCopyFromPrevious = () => {
        const test = this.state.test;
        const copyPump = test.pumpData.pumps[test.pumpData.pumps.length - 1];
        let pump = new IPump();
        if (copyPump) {
            pump = JSON.parse(JSON.stringify(copyPump));
            pump.id = '';
        }

        this.setState({pump});
    }

    private handleInlineRadio = (index: any) => (event: any) => {
        const test = this.state.test;
        const pump = test.pumpData.pumps[index];
        pump.onJob = !pump.onJob;
        this.TestsStore.calculatePumpData(test);
        this.setState({
            isDirty: true,
            test
        });
    }

    private handleInlineInput = (index: any) => (event: any) => {
        const test = this.state.test;
        const pump = test.pumpData.pumps[index];
        pump[event.target.name] = event.target.value;
        this.TestsStore.calculatePumpData(test);
        this.setState({
            isDirty: true,
            test,
        });
    }

    private renderInlineInput = (index: any, name: string, iWidth?: number) => () => {
        const pump = this.state.test.pumpData.pumps[index];
        if (pump) {

            return (
                <EInput
                key={index+name}
                style={iWidth ? {width: iWidth + 'px'} : {}}
                type="text"
                name={name}
                id={name + index}
                value={pump[name]}
                data-validation={name === 'efficiency' ? "integer" : undefined}
                onChange={this.handleInlineInput(index)}
                onKeyDown={this.selectNext(index, name)}
                onBlur={this.formatDataTable}
                autoComplete="off"
                />
            );
        }
        return '';
    }

    private renderActiveInput = (index: any) => () => {
        if (this.state.test.pumpData.pumps[index]) {

            const pumpOnJob = this.state.test.pumpData.pumps[index].onJob;
            return (
            <div>
                <FormGroup check={true} inline={true}>
                    <Label check={true}>
                        <Input
                            name={"onJob" + index}
                            id={"onJob" + index}
                            type="radio"
                            value="true"
                            onChange={this.handleInlineRadio(index)}
                            checked={pumpOnJob}
                            /> Yes
                    </Label>
                </FormGroup>
                <FormGroup check={true} inline={true}>
                    <Label check={true}>
                        <Input
                            name={"onJob" + index}
                            id={"onJob" + index}
                            type="radio"
                            value="false"
                            onChange={this.handleInlineRadio(index)}
                            checked={!pumpOnJob}
                        /> No
                    </Label>
                </FormGroup>
            </div>
            );
        }
        return '';
    }

    private selectNext = (index:number, name: string) => (event:any) => {
        event.persist();
        setTimeout(() => {
            if (event.keyCode && event.keyCode === 9) {
                if (name === 'efficiency') {
                    const stkEle: any = document.getElementById('stkMin' + index);
                    if (stkEle) {
                        stkEle.focus();
                        stkEle.select();
                    }
                } else {
                    const efficiencyEle:any = document.getElementById('efficiency' + (index + 1));
                    if (efficiencyEle) {
                        efficiencyEle.focus();
                        efficiencyEle.select();
                    }
                }
            }
        }, 100);
    }
    private formatDataTable = (event?: any) => {
        if(event) {
            event.persist();
        }
        const newDataList: any[] = [];
        const tableHeaders = [
            'Pump',
            'Make/Model',
            'Liner Qty',
            'Liner Size',
            'Stk Length',
            'Rod Size',
            'Active',
            '% Eff',
            'Stk/Min',
            'bbl/stk',
            'bbl/min',
            'gal/min'
        ];
        if ( this.state.test.pumpData.pumps ) {
            this.state.test.pumpData.pumps.map((pump: IPump, index: number) => {
                const newObject = [
                    {
                        content: pump.pumpNumber
                    },
                    {
                        content: pump.make + '/' + pump.model
                    },
                    {
                        content: pump.linerQty
                    },
                    {
                        content: pump.linerSize
                    },
                    {
                        content: pump.stkLength
                    },
                    {
                        content: pump.rodSize
                    },
                    {
                        content: this.renderActiveInput(index),
                        sortItem: pump.onJob,
                        type: 'render'

                    },
                    {
                        content: this.renderInlineInput(index, 'efficiency'),
                        sortItem: pump.efficiency,
                        type: 'render'
                    },
                    {
                        content: this.renderInlineInput(index, 'stkMin'),
                        sortItem: pump.stkMin,
                        type: 'render'
                    },
                    {
                        content: pump.bblStk
                    },
                    {
                        content: pump.bblMin
                    },
                    {
                        content: pump.galMin
                    }
                ];
                newDataList.push(newObject);
            });
        }
        const listStructure = {
            headers: tableHeaders,
            rows: newDataList
        };
        this.setState({
            dataSet: listStructure
        });
    }

    public async componentWillUnmount() {
        this.clearDisposers();
    }

    public clearDisposers() {
        if ( this.testDisposer ) {
            this.testDisposer();
        }
        if ( this.wellDisposer ) {
            this.wellDisposer();
        }
    }

    private toggleModal = () => {
        this.setState({
            modal: !this.state.modal
        });
    }

    private handleCancel = () => {
        this.setState({
            editing: false,
            modal: false,
            pump: new IPump()
        });
    }

    private handleSave = (addAnother: boolean) => () => {
        const test = this.state.test;
        if (!Array.isArray(test.pumpData.pumps)) {
            test.pumpData.pumps = [];
        }

        if ( this.state.editing ) {
            test.pumpData.pumps[this.state.rowIndex] = this.state.pump;
        } else {
            const currPumpNumber = test.pumpData.pumps.length;
            this.state.pump.pumpNumber = currPumpNumber + 1;
            test.pumpData.pumps.push(this.state.pump);
        }

        
        this.TestsStore.calculatePumpData(test);
        this.setState({
            editing: false,
            isDirty: true,
            pump: new IPump(),
            test
        }, () => {
            this.formatDataTable();
        });

        if (!addAnother) {
            this.toggleModal();
        }
    }

    private handleEdit = (index: number) => {
        const pump = DeepCopy(this.state.test.pumpData.pumps[index]);

        this.setState({
            editing: true,
            pump,
            rowIndex: index,

        }, () => {
            this.toggleModal();
        });
    }

    private handleDelete = (index: number) => {
        const test = this.state.test;
        const pumps = test.pumpData.pumps;
        pumps.splice(index, 1);
        test.pumpData.pumps = pumps;
        this.setState({
            isDirty: true,
            test
        });
        this.formatDataTable();
    }

    private handleInputChange = (event: any) => {
        const test = this.state.test;
        test.pumpData[event.target.name] = event.target.value;
        this.setState({
            isDirty: true,
            test
        });
    }

    private handleModalInputChange = (event: any) => {
        const pump = this.state.pump;
        pump[event.target.name] = event.target.value;
        this.setState({
            pump
        });
    }

    private handleRadioSelect = (event: any) => {
        if ( ! this.state.editing ) {
            const pump = this.state.pump;
            const onJob = event.target.value;
            pump[event.target.name] = ( onJob === 'true' );
            this.setState({
                pump
            });
        } else {
            const test = this.state.test;
            const onJob = event.target.value;
            test.pumpData.pumps[this.state.rowIndex][event.target.name] = ( onJob === 'true');
            this.setState({
                test
            });
        }
    }

    private updateTestModel = () => {
        this.TestsStore.updateTestModel(this.state.test, this.props.match.params.wellId).then((test:any) => {
            if (test) {
                this.setState({
                    isDirty: false,
                });
            }
        });
    }

    private buttonNavigation = (event: any) => {
        const $target = event.target;
        if ( $target.name === 'previous' ) {
            this.props.history.push('/well/' + this.props.match.params.wellId + '/test/' + this.props.match.params.taskId + '/holegeometry/survey');
        } else {
            this.props.history.push('/well/' + this.props.match.params.wellId + '/test/' + this.props.match.params.taskId + '/fluiddata/mudproperties');
        }
    }

    private rodSizeRequired() {
        if (!this.state.editing) {
            return Number(this.state.pump.linerQty) === 2;
        } else {
            return Number(this.state.test.pumpData.pumps[this.state.rowIndex].linerQty) === 2;
        }
    }

    private invalidLinerQty() {
        if (!this.state.editing) {
            return Number(this.state.pump.linerQty) < 2;
        } else {
            return Number(this.state.test.pumpData.pumps[this.state.rowIndex].linerQty) < 2;
        }
    }

    private checkDecimalPlaces = (value: any, maxDecimal: number) => () => {
        return decimalPlaces(value) > maxDecimal;
    }
    private disableSaveDecimalPlaces = () => {
        return this.checkDecimalPlaces(this.state.pump.linerSize, 2)()
            || this.checkDecimalPlaces(this.state.pump.stkLength, 2)()
            || this.checkDecimalPlaces(this.state.pump.rodSize, 2)();
    }

    private saveDisabled() {
        return this.invalidLinerQty() || ( this.rodSizeRequired() && this.state.pump.rodSize < 1 ) || this.disableSaveDecimalPlaces();
    }

    private rodSizeDisabled() {
        if (!this.state.editing) {
            return Number(this.state.pump.linerQty) !== 2;
        } else {
            return Number(this.state.test.pumpData.pumps[this.state.rowIndex].linerQty) !== 2;
        }
    }

    public render() {
        const copyFromPrevDisabled = !(this.state.test && this.state.test.pumpData && this.state.test.pumpData.pumps && this.state.test.pumpData.pumps.length > 0);
        const currWell = this.WellsStore.well;
        const disableWellStatus = currWell !== undefined && currWell.wellStatus !== 'Active';
        return(
            <div className="DrillingPump">
            <Prompt when={this.state.isDirty} message={"Changes have been made.\n\nPress Cancel then Press Save OR Press OK to continue without saving."} />
                <WorkflowHeader workflowHeaderItems={this.props.workflowHeaderItems} isInventoryReport={this.state.test.isInventoryReport}/>
                <Row>
                    <Col md="9">
                        <Row>
                            <Col md="12">
                                <h4>Circulation Data</h4>
                            </Col>
                            <Col md="4">
                                <FormGroup>
                                    <Label>Circ Pressure</Label>
                                    <EInput
                                        type="text"
                                        name="circPressure"
                                        id="circPressure"
                                        data-validation="integer"
                                        value={this.state.test.pumpData.circPressure}
                                        onChange={this.handleInputChange}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                    </Col>
                    <Col md="3">
                        <h4>Volume Data</h4>
                        <FormGroup>
                            <Label>Pit Volume</Label>
                            <EInput
                                type="text"
                                name="pitVolume"
                                id="pitVolume"
                                data-validation="integer"
                                value={this.state.test.pumpData.pitVolume}
                                onChange={this.handleInputChange}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col md="3">
                        <FormGroup>
                            <Label>Surface to Bit Stks</Label>
                            <EInput
                                type="text"
                                disabled={true}
                                value={this.state.test.pumpData.surfaceToBitStks}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Bottoms Up Stks</Label>
                            <EInput
                                type="text"
                                disabled={true}
                                value={this.state.test.pumpData.bottomsUpStks}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Surface to Surface Stks</Label>
                            <EInput
                                type="text"
                                disabled={true}
                                value={this.state.test.pumpData.surfaceToSurfaceStks}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Active Vol Stks</Label>
                            <EInput
                                type="text"
                                disabled={true}
                                value={this.state.test.pumpData.activeVolumeStks}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="3">
                        <FormGroup>
                            <Label>Surface to Bit Min</Label>
                            <EInput
                                type="text"
                                disabled={true}
                                value={this.state.test.pumpData.surfaceToBitMinutes}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Bottoms Up Min</Label>
                            <EInput
                                type="text"
                                disabled={true}
                                value={this.state.test.pumpData.bottomsUpTime}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Surface to Surface Min</Label>
                            <EInput
                                type="text"
                                disabled={true}
                                value={this.state.test.pumpData.surfaceToSurfaceMinutes}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Active Vol Min</Label>
                            <EInput
                                type="text"
                                disabled={true}
                                value={this.state.test.pumpData.activeVolumeMinutes}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="3">
                        <Row>
                            <Col md="6">
                            <FormGroup>
                                <Label>AVDP (fpm)</Label>
                                <EInput
                                    type="text"
                                    disabled={true}
                                    value={this.state.test.pumpData.avdp}
                                    />
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label>AVDP (fps)</Label>
                                <EInput
                                    type="text"
                                    disabled={true}
                                    value={Number((this.state.test.pumpData.avdp) / 60).toFixed(2)}
                                    />
                            </FormGroup>
                        </Col>
                        </Row>
                        <Row>
                            <Col md="6">
                                <FormGroup>
                                    <Label>AVDC (fpm)</Label>
                                    <EInput
                                        type="text"
                                        disabled={true}
                                        value={this.state.test.pumpData.avdc}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="6">
                                <FormGroup>
                                    <Label>AVDC (fps)</Label>
                                    <EInput
                                        type="text"
                                        disabled={true}
                                        value={(Number(this.state.test.pumpData.avdc) / 60).toFixed(2)}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <FormGroup>
                            <Label>Critical Velocity</Label>
                            <EInput
                                type="text"
                                disabled={true}
                                value={this.state.test.pumpData.criticalVelocity}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Flow Type</Label>
                            <EInput
                                type="text"
                                disabled={true}
                                value={this.state.test.pumpData.flowType}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="3">
                        <FormGroup>
                            <Label>Surface to Bit (bbl)</Label>
                            <EInput
                                type="text"
                                disabled={true}
                                value={this.state.test.pumpData.surfaceToBitBarrels}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Bottoms Up (bbl)</Label>
                            <EInput
                                type="text"
                                disabled={true}
                                value={this.state.test.pumpData.bottomsUpBarrels}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Surface to Surface (bbl)</Label>
                            <EInput
                                type="text"
                                disabled={true}
                                value={this.state.test.pumpData.surfaceToSurfaceBarrels}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Active Vol (bbl)</Label>
                            <EInput
                                type="text"
                                disabled={true}
                                value={this.state.test.pumpData.activeVolumeBarrels}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="12">
                        <hr/>
                    </Col>
                    <Col md="3">
                        <FormGroup>
                            <Label>Total Stks Per Min</Label>
                            <EInput
                                type="text"
                                disabled={true}
                                value={this.state.test.pumpData.totalStksMin}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="3">
                        <FormGroup>
                            <Label>Total bbl/min</Label>
                            <EInput
                                type="text"
                                disabled={true}
                                value={this.state.test.pumpData.totalBblMin}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="3">
                        <FormGroup>
                            <Label>Total gal/min</Label>
                            <EInput
                                type="text"
                                disabled={true}
                                value={this.state.test.pumpData.totalGalMin}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="3">
                        <FormGroup>
                            <Label>Vol Below Bit</Label>
                            <EInput
                                type="text"
                                disabled={true}
                                value={this.state.test.pumpData.volumeBelowBit}
                            />
                        </FormGroup>
                    </Col>
                    <Col md={{size: 3, offset: 9}}>
                        <FormGroup>
                            <Label>Current Hole Volume</Label>
                            <EInput
                                type="text"
                                disabled={true}
                                value={this.state.test.pumpData.holeCapacity}
                            />
                        </FormGroup>
                    </Col>
                </Row>

                <Row>
                    <Col md="12">
                        <h4 className="table-h4">Pump Selection</h4>
                        <DataTable
                            list={this.state.dataSet}
                            onNew={{
                                callback: this.toggleModal,
                                text: 'Add Pump'
                            }}
                            onEdit={this.handleEdit}
                            onDelete={this.handleDelete}
                            disableEditing={disableWellStatus}
                        />
                    </Col>
                </Row>
                <Footer well={this.WellsStore.well} test={this.TestsStore.test} onSave={this.updateTestModel} onNavigate={this.buttonNavigation} />
                <Modal isOpen={this.state.modal} fade={false} toggle={this.toggleModal}>
                    <ModalHeader toggle={this.toggleModal}>
                        { this.state.editing ? 'Edit Pump' : 'Add New Pump' }
                    </ModalHeader>
                    <ModalBody>
                        <Form>
                            <Row>
                                <Col md="6">
                                    <FormGroup className="required">
                                        <Label>Make</Label>
                                        <EInput
                                            type="text"
                                            name="make"
                                            id="make"
                                            required={true}
                                            value={this.state.pump.make}
                                            onChange={this.handleModalInputChange}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup className="required">
                                        <Label>Model</Label>
                                        <EInput
                                            type="text"
                                            name="model"
                                            id="model"
                                            required={true}
                                            value={this.state.pump.model}
                                            onChange={this.handleModalInputChange}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup className="required">
                                        <Label>Liner Qty</Label>
                                        <EInput
                                            type="text"
                                            name="linerQty"
                                            id="linerQty"
                                            data-validation="integer"
                                            data-min={2}
                                            required={true}
                                            value={this.state.pump.linerQty}
                                            onChange={this.handleModalInputChange}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup className="required">
                                        <Label>Liner Size</Label>
                                        <EInput
                                            type="text"
                                            name="linerSize"
                                            data-validation="decimal"
                                            required={true}
                                            id="linerSize"
                                            value={this.state.pump.linerSize}
                                            onChange={this.handleModalInputChange}
                                            errorCallback={{
                                                callback: this.checkDecimalPlaces(this.state.pump.linerSize, 2),
                                                message: 'Value has a maximum of 2 decimal places.'
                                            }}
                                        />
                                    </FormGroup>
                                </Col>
                                    <Col md="6">
                                        <FormGroup className="required">
                                            <Label>Stk Length</Label>
                                            <EInput
                                                type="text"
                                                name="stkLength"
                                                id="stkLength"
                                                required={true}
                                                data-validation="decimal"
                                                value={this.state.pump.stkLength}
                                                onChange={this.handleModalInputChange}
                                                errorCallback={{
                                                    callback: this.checkDecimalPlaces(this.state.pump.stkLength, 2),
                                                    message: 'Value has a maximum of 2 decimal places.'
                                                }}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="6">
                                        <FormGroup className={this.rodSizeRequired() ? 'required' : ''}>
                                            <Label>Rod Size</Label>
                                            <EInput
                                                type="text"
                                                name="rodSize"
                                                id="rodSize"
                                                data-validation="decimal"
                                                required={this.rodSizeRequired()}
                                                value={ this.rodSizeDisabled() ? 0 : Number(this.state.pump.rodSize)}
                                                onChange={this.handleModalInputChange}
                                                disabled={this.rodSizeDisabled()}
                                                errorCallback={{
                                                    callback: this.checkDecimalPlaces(this.state.pump.rodSize, 2),
                                                    message: 'Value has a maximum of 2 decimal places.'
                                                }}
                                            />
                                        </FormGroup>
                                    </Col>
                                <Col md="4">
                                    <Label>Active</Label><br/>
                                    <FormGroup check={true} inline={true}>
                                        <Label check={true}>
                                            <Input
                                                name="onJob"
                                                id="onJob"
                                                type="radio"
                                                value="true"
                                                onChange={this.handleRadioSelect}
                                                checked={this.state.pump.onJob}
                                            /> Yes
                                        </Label>
                                    </FormGroup>
                                    <FormGroup check={true} inline={true}>
                                        <Label check={true}>
                                            <Input
                                                name="onJob"
                                                id="onJob"
                                                type="radio"
                                                value="false"
                                                onChange={this.handleRadioSelect}
                                                checked={!this.state.pump.onJob}
                                            /> No
                                        </Label>
                                    </FormGroup>
                                </Col>
                                <Col md="4">
                                    <FormGroup className="required">
                                        <Label>% Eff</Label>
                                        <EInput
                                            type="text"
                                            name="efficiency"
                                            id="efficiency"
                                            required={true}
                                            data-validation="integer"
                                            value={this.state.pump.efficiency}
                                            onChange={this.handleModalInputChange}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="4">
                                    <FormGroup>
                                        <Label>Stk/Min</Label>
                                        <EInput
                                            type="text"
                                            name="stkMin"
                                            id="stkMin"
                                            data-validation="decimal"
                                            value={this.state.pump.stkMin}
                                            onChange={this.handleModalInputChange}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                        </Form>
                    </ModalBody>
                    <ModalFooter>
                        <Button className="secondary" onClick={this.handleCancel}>Cancel</Button>
                        { 
                            !this.state.editing && 
                            <Button color="primary" onClick={this.handleCopyFromPrevious} disabled={copyFromPrevDisabled}>Copy From Previous</Button>
                        }
                        <EButton color="primary" disabled={this.saveDisabled()} onClick={this.handleSave(false)}>Update</EButton>
                        {
                            !this.state.editing &&
                            <EButton color="primary" disabled={this.saveDisabled()} onClick={this.handleSave(true)}>Add Another</EButton>

                        }
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

export default withRouter(DrillingPump);



// WEBPACK FOOTER //
// ./src/Components/Main/TestWorkflow/DrillingPump/DrillingPump.tsx